export const GET_UNASSIGNED_JOBS = "GET_UNASSIGNED_JOBS";
export const ACCEPT_UNASSIGNED_JOB = "ACCEPT_UNASSIGNED_JOB";
export const GET_CONTRACTOR_CURRENT_JOBS = "GET_CONTRACTOR_CURRENT_JOBS";
export const UPLOAD_EDITED_DOCUMENT = "UPLOAD_EDITED_DOCUMENT";
export const REPORT_UNEDITABLE_DOCUMENT = "REPORT_UNEDITABLE_DOCUMENT";
export const GET_FINISHED_JOBS = "GET_FINISHED_JOBS";
